module.exports = __webpack_public_path__ + "img/couples-027.5858f418.jpg";